export const REGISTRY_CONTRACT_ADDRESS = '0xd976d3b4f4e22a238c1A736b6612D22f17b6f64C';
//# sourceMappingURL=constants.js.map